import { useTranslation } from 'react-i18next';
import { AppDispatch, AppStore } from '../../../store';
import { EApiType, EDataTableType, EModuleType } from '../../../data/Constants';
import { MaintenanceTable } from '../../DataTable/DataTable';
import { joinSelectedKeys } from '../../../services/DataHelperFunctions';
import { getMarkets, deleteMarket } from '../../../store/states/MarketSlice';
import { setAlertMessage } from '../../../store/states/AlertMessageSlice';
import { useDispatch } from 'react-redux';
import { useApiError } from '../../../hooks';

import type { IManagementProps } from '../../../../types';

export const MarketManagement = (props: IManagementProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const errorElement = useApiError(EApiType.MarketKey);

  if (errorElement) return errorElement;

  const deleteItems = (req) => {
    const markets = AppStore.getState().dataMaintainance.markets;
    dispatch(deleteMarket({ token: props.token, request: req })).then((res) => {
      const delkeys = joinSelectedKeys(req);
      if (res.payload?.data) {
        const message = t('messages.success.delete.markets', { length: req.length, list: delkeys });
        dispatch(setAlertMessage({ show: true, message: message, type: 'success' }));
        dispatch(
          getMarkets({
            token: props.token,
            page: markets.currentPage,
            limit: markets.recordsPerPage,
            searchCode: markets.searchKey,
          })
        );
      } else {
        const message = t('messages.fail.delete.markets', { length: req.length, list: delkeys });
        dispatch(setAlertMessage({ show: true, message: message, type: 'error' }));
      }
    });
  };

  return (
    <>
      <h3 className="mainHeader"> {t('labels.marketManagement')}</h3>
      <MaintenanceTable
        token={props.token}
        type={EDataTableType.Markets}
        getDataList={getMarkets}
        moduleType={EModuleType.Datamaintainance}
        deleteItems={deleteItems}
      />
    </>
  );
};
